import "./Test.scss";
import React, { useState } from "react";
// import { HashLoader } from "react-spinners";
import artbord from "../../assets/images/login.svg";
const Test = () => {
  return (
    <>
      <div className="grid gap-8 sm:grid-cols-2 my-10">
        <p className="text-center sm:text-left">
          Lorem ipsum dolor, sit amet consectetur adipisicing elit. Sint
          blanditiis incidunt, doloribus vitae reiciendis perferendis maiores
          magnam dolor officia quis quae fugiat vel sapiente modi molestias
          iste, officiis numquam distinctio?
        </p>
        <img className="w-full h-[300px]" src={artbord} alt="" />
      </div>
    </>
  );
};

export default Test;
